import express from 'express';
import {
  DEFAULT_PROTO,
  DEFAULT_DOMAIN,
  customHeaders,
} from 'shared/constants/requestHeaders';
import { State } from 'store/types';
import statusCodes from 'constants/statusCodes';
import { DEFAULT_LOG_DIR } from 'shared/logging/constants';
import { REMOTE_CONFIG_KEY_IN_LOCALS } from './../constants/index';

export const getStatusCode = (state: State) =>
  state.appReducer?.statusCode || statusCodes.SUCCESS;

const getUrlWithoutQueryString = (str: string) => {
  try {
    let occurrence = str.indexOf('?');
    let urlWithoutQueryString = '';
    if (occurrence != -1) {
      urlWithoutQueryString = str.substring(0, occurrence);
    } else {
      urlWithoutQueryString = str;
    }
    return urlWithoutQueryString;
  } catch (e) {
    return '';
  }
};

const getHostFromRequestHeaders = (requestHeaders: any): string =>
  requestHeaders[customHeaders.DOMAIN_NAME] || DEFAULT_DOMAIN;

const getRequestProtocol = (requestHeaders: any): string =>
  requestHeaders[customHeaders.FORWARDED_PROTOTYPE] || DEFAULT_PROTO;

const canonicalBuilder = (url: string, req: any): string => {
  if (!url || !req) {
    return '';
  }
  return `${getRequestProtocol(req.headers)}://${getHostFromRequestHeaders(
    req.headers
  )}${url}`;
};

export const getCanonicalFromRequest = (req: any): string => {
  if (!req) {
    return '';
  }
  try {
    const browserUrl = req.header(customHeaders.BROWSER_URL);
    let canonicalUrl = '';
    const canonicalUrlFromHeader = req.header(customHeaders.CANONICAL_URL);
    const xOriginalUrl = req.header(customHeaders.ORIGINAL_URL);
    const urlWithoutParams = req.originalUrl.split('?');
    if (canonicalUrlFromHeader) {
      canonicalUrl = canonicalUrlFromHeader;
    } else if (xOriginalUrl) {
      canonicalUrl = getUrlWithoutQueryString(xOriginalUrl);
    } else if (browserUrl) {
      canonicalUrl = browserUrl.split('?')[0];
    } else {
      canonicalUrl = canonicalBuilder(urlWithoutParams[0], req);
    }
    return canonicalUrl;
  } catch (error) {
    //TODO: log error
    return '';
  }
};

export const isNonDev = (): boolean =>
  process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'production';

export const getLogDir = () => process.env.LOG_DIR || DEFAULT_LOG_DIR;
export const videoConsultationRedirect = (
  req: express.Request,
  res: express.Response,
  next: express.NextFunction
) => {
  const {
    switches: { videoConsultation },
  } = res.locals[REMOTE_CONFIG_KEY_IN_LOCALS];
  if (!videoConsultation) {
    return res.redirect(307, '/');
  } else {
    next();
  }
};

export const hlpRedirect = (
  req: express.Request,
  res: express.Response,
  next: express.NextFunction
) => {
  const { query, params, cookies, _parsedUrl } = req;
  const { search } = _parsedUrl;
  const { id } = params;
  const { utm_source, affiliateId, adId } = query;
  const {
    configs: { hlpIdentifier, hlpUtmSource },
  } = res.locals[REMOTE_CONFIG_KEY_IN_LOCALS];
  let isValidSource = false;
  let isValidIdentifier = !hlpIdentifier;
  if (utm_source && hlpUtmSource?.length > 0) {
    isValidSource = hlpUtmSource?.includes(utm_source);
  }
  if (hlpIdentifier && query?.hlp && query.hlp === hlpIdentifier) {
    isValidIdentifier = true;
  }
  const { EXP_AB_HLP_PAGE, EXP_AB_HLP_AFFILIATE } = cookies;
  let updatedSearchQuery = search;
  if (hlpIdentifier) {
    updatedSearchQuery = search
      ?.split('&')
      .filter((item: string | string[]) => !item.includes(hlpIdentifier))
      .join('&');
  }
  const isValidRedirection =
    isValidIdentifier &&
    isValidSource &&
    EXP_AB_HLP_PAGE &&
    EXP_AB_HLP_PAGE === 'A';

  const isValidAffiliateRedirection =
    affiliateId && adId && EXP_AB_HLP_AFFILIATE === 'A';

  if (isValidRedirection || isValidAffiliateRedirection) {
    return res.redirect(307, `/hlp/${id}${updatedSearchQuery}`);
  }
  next();
};

export const checkNewrelicClient = (sampleRate: number) => {
  const randomSample = Math.random();
  if (sampleRate > 0 && sampleRate >= randomSample) {
    return true;
  }
  return false;
};
